export const createKeyMap = <K extends PropertyKey, T extends Record<K, PropertyKey>>(list: readonly T[], key: K) => {
  return list.reduce(
    (acc, curr) => {
      acc[curr[key]] = curr;
      return acc;
    },
    // TS can't verify the seed grows to cover every key during reduction
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {} as Record<T[K], T>
  );
};
